import { useEffect, useState } from "react";
import { Download, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { downloadFile } from "@/lib/pdf";

const STATUS = { new: "Nowe", quoted: "Wycena wysłana", done: "Zrealizowane" };

export function QuotesAdmin() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/legalization-quotes").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-slate-600" /></div>;

  const setStatus = async (q, status) => {
    try { await api.patch(`/admin/legalization-quotes/${q.id}/status`, null, { params: { status } }); load(); } catch { toast.error("Nie udało się zmienić statusu."); }
  };
  const remove = async (q) => {
    if (!window.confirm("Usunąć to zgłoszenie?")) return;
    try { await api.delete(`/admin/legalization-quotes/${q.id}`); toast.success("Zgłoszenie usunięte."); load(); } catch { toast.error("Nie udało się usunąć."); }
  };
  const download = async (q) => {
    try { await downloadFile({ method: "get", url: `/admin/legalization-quotes/${q.id}/file` }, q.file.filename); } catch { toast.error("Nie udało się pobrać pliku."); }
  };

  return (
    <div data-testid="quotes-admin" className="space-y-4">
      <div className="bg-card border border-border rounded-2xl p-5 sm:p-6">
        <h2 className="font-display font-bold text-lg">Wyceny — legalizacja dokumentów</h2>
        <p className="text-sm text-muted-foreground mt-1">Zgłoszenia z formularza „Zgłoś dokument do darmowej weryfikacji B2B” na podstronie legalizacji. Skany są też dołączane do e-maila na adres biura.</p>
      </div>
      {items.length === 0 && <p data-testid="quotes-empty" className="text-sm text-muted-foreground">Brak zgłoszeń.</p>}
      {items.map((q) => (
        <div key={q.id} data-testid={`quote-${q.id}`} className="bg-card border border-border rounded-2xl p-5 sm:p-6">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-semibold">{q.name}{q.company ? ` · ${q.company}` : ""}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{q.created_at.slice(0, 16).replace("T", " ")} · <a href={`mailto:${q.email}`} className="underline">{q.email}</a>{q.phone ? ` · ${q.phone}` : ""}</p>
            </div>
            <div className="flex items-center gap-2">
              <select data-testid={`quote-status-${q.id}`} value={q.status} onChange={(e) => setStatus(q, e.target.value)} className="text-xs font-semibold border border-border rounded-full px-3 py-1.5 bg-background">
                {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
              {q.file && <button type="button" data-testid={`quote-download-${q.id}`} onClick={() => download(q)} className="inline-flex items-center gap-1.5 text-xs font-semibold border border-border rounded-full px-3 py-1.5 hover:bg-muted"><Download size={13} /> {q.file.filename}</button>}
              <button type="button" data-testid={`quote-delete-${q.id}`} onClick={() => remove(q)} aria-label="Usuń" className="p-2 rounded-full hover:bg-destructive/10 text-destructive"><Trash2 size={15} /></button>
            </div>
          </div>
          <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-1 text-sm">
            <p><span className="text-muted-foreground">Kraj docelowy:</span> {q.country}</p>
            <p><span className="text-muted-foreground">Język tłumaczenia:</span> {q.language || "—"}</p>
            <p><span className="text-muted-foreground">Rodzaj dokumentu:</span> {q.doc_type || "—"}</p>
          </div>
          {q.message && <p className="text-sm text-muted-foreground mt-3 whitespace-pre-wrap border-t border-border pt-3">{q.message}</p>}
        </div>
      ))}
    </div>
  );
}
